import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import { Card } from '../../../component';
import React from 'react';
import './index.css';
import { isSmartPhone } from '../../../utilities/helper';
import HomeTabBarMWeb from './index_mWeb';
import useTheme from '../../../utilities/hooks/theme';
interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
  myTeamCount?: number;
  myContestsCount?: number;
}
const HomeTabBar = ({
  onChangeTab,
  activeTab,
  routes = [],
  myTeamCount = 0,
  myContestsCount = 0
}: Props) => {
  const { FantasyTheme: theme } = useTheme();

  if (isSmartPhone) {
    return (
      <HomeTabBarMWeb
        onChangeTab={onChangeTab}
        activeTab={activeTab}
        routes={routes}
        myTeamCount={myTeamCount}
        myContestsCount={myContestsCount}
      />
    );
  }
  return (
    <div className="cricket_home_category_tabs">
      <Card
        style={{
          flex: 1,
          // width: '60%',
          backgroundColor: 'transparent'
        }}>
        <Tabs
          onChange={onChangeTab}
          value={activeTab}
          style={{
            minHeight: 0,
            padding: 0
            // borderBottom: '0.5px solid #808594'
          }}
          TabIndicatorProps={{ style: { background: 'transparent' } }}>
          {routes.map((item: any, index: any) => {
            const { key, title } = item;
            const isActive = activeTab === index;
            return (
              <Tab
                key={key}
                style={{
                  flex: 1,
                  minHeight: 0,
                  padding: 0,
                  fontSize: '16px',
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  // backgroundColor: isActive ? theme.homeTabActiveBG : theme.homeTabInActiveBG,
                  // borderLeftColor: theme.homeTabBorderLeftColor,
                  // borderLeftWidth: index > 0 ? '3px' : 0,
                  // borderLeftStyle: 'solid',

                  background: isActive ? theme.matchTabActivebg : theme.matchTabDefaultBg,
                  color: isActive ? '#000' : '#fff',
                  textTransform: 'none',
                  height: '40px',
                  // borderBottom: '1px solid white',
                  borderLeft: index === 1 ? '0.5px solid #808594' : '',
                  borderRight: index === 1 ? '0.5px solid #808594' : ''
                }}
                label={`${title} ${
                  key === 'MyContests'
                    ? `(${myContestsCount})`
                    : key === 'MyTeams'
                    ? `(${myTeamCount})`
                    : ''
                }`}
                value={index}
              />
            );
          })}
        </Tabs>
      </Card>
    </div>
  );
};
export default React.memo(HomeTabBar);
